(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imagevideo"] && !Shopify.designMode) return;
  try {
    
  class ImageVideoSection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.triggers = Array.from(this.querySelectorAll('[data-tab-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.setActiveTab(trigger.dataset.tabTrigger));
      });

      this.setActiveTab(this.dataset.defaultTab || 'photo');
    }

    setActiveTab(tab) {
      this.triggers.forEach((trigger) => {
        const isActive = trigger.dataset.tabTrigger === tab;
        trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.tabPanel !== tab;
      });

      this.syncPanelMedia(tab);
    }

    syncPanelMedia(activeTab) {
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === activeTab;

        panel.querySelectorAll('deferred-media').forEach((media) => {
          if (isActive) {
            media.loadContent?.(false);
            media.playMedia?.();
          } else {
            media.pauseMedia?.();
          }
        });

        panel.querySelectorAll('video').forEach((video) => {
          if (isActive) {
            const playPromise = video.play?.();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause?.();
          }
        });

        panel.querySelectorAll('iframe[data-video-type]').forEach((iframe) => {
          iframe.contentWindow?.postMessage(
            iframe.dataset.videoType === 'youtube'
              ? '{"event":"command","func":"' + (isActive ? 'playVideo' : 'pauseVideo') + '","args":""}'
              : '{"method":"' + (isActive ? 'play' : 'pause') + '"}',
            '*'
          );
        });
      });
    }
  }

  if (!customElements.get('image-video-section')) {
    customElements.define('image-video-section', ImageVideoSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
